import { IProjectPondParameter } from '../../interfaces/iproject-pond-parameter';
import { Asset } from '../asset';
import { FenceType } from '../fence-type';
import { Field } from '../field';
import { LinerType } from '../liner-type';
import { PermitType } from '../permit-type';
import { PondSize } from '../pond-size';
import { Project } from '../project';
import { TeamDevelopmentArea } from '../team-development-area';
import { WaterType } from '../water-type';

export class ProjectPondParameterBase {
  ProjectPondParameterId: number;
  AdditionalDetails: string | null;
  AssetId: number | null;
  FenceTypeId: number | null;
  FieldId: number | null;
  LinerTypeId: number | null;
  PermitTypeId: number | null;
  PondSizeId: number | null;
  ProjectId: number | null;
  TeamDevelopmentAreaId: number | null;
  WaterTypeId: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Asset?: Asset;
  FenceType?: FenceType;
  Field?: Field;
  LinerType?: LinerType;
  PermitType?: PermitType;
  PondSize?: PondSize;
  Project?: Project;
  TeamDevelopmentArea?: TeamDevelopmentArea;
  WaterType?: WaterType;

  constructor(item?: IProjectPondParameter) {
    if (item) {

      this.ProjectPondParameterId = item.ProjectPondParameterId;
      this.AdditionalDetails = item.AdditionalDetails;
      this.AssetId = item.AssetId;
      this.FenceTypeId = item.FenceTypeId;
      this.FieldId = item.FieldId;
      this.LinerTypeId = item.LinerTypeId;
      this.PermitTypeId = item.PermitTypeId;
      this.PondSizeId = item.PondSizeId;
      this.ProjectId = item.ProjectId;
      this.TeamDevelopmentAreaId = item.TeamDevelopmentAreaId;
      this.WaterTypeId = item.WaterTypeId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Asset = new Asset(item.Asset);
      this.FenceType = new FenceType(item.FenceType);
      this.Field = new Field(item.Field);
      this.LinerType = new LinerType(item.LinerType);
      this.PermitType = new PermitType(item.PermitType);
      this.PondSize = new PondSize(item.PondSize);
      this.Project = new Project(item.Project);
      this.TeamDevelopmentArea = new TeamDevelopmentArea(item.TeamDevelopmentArea);
      this.WaterType = new WaterType(item.WaterType);
    }
  }
}